import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export enum AppActionTypes {
    LOGOUT = '[App] logout',
    GO = "[App] GO",
    BACK = "[App] BACK",
    FORWARD = "[App] FORWARD"
  }
export const GO = '[Router] Go';
export const BACK = '[Router] Back';
export const FORWARD = '[Router] Forward';

export class Logout implements Action {
    readonly type = AppActionTypes.LOGOUT;
}

export class Go implements Action {
  readonly type = GO;
  constructor(
    public payload: {
      path: any[];
      query?: object;
      extras?: NavigationExtras;
    }
  ) {}
}

export class Back implements Action {
  readonly type = BACK;
}

export class Forward implements Action {
  readonly type = FORWARD;
}

export class RouteChange implements Action {
  readonly type = '[Router] Route Change';
  constructor(public payload: { params: any, path: string }) {}
}

export type AppActionsUnion =
  | Logout
  | Go
  | Back
  | Forward;
